export const COLORS = {
    dark: '#797272',
};